import amount from "./modules/amount";
import calcDisc from "./modules/calcDisc";
import changeAddress from "./modules/changeAddress";
import customSelect from "./modules/customSelect";
import edit from "./modules/edit";
import faq from "./modules/faq";
import filter from "./modules/filter";
import modals from "./modules/modals";
import addFavorite from "./modules/addFavorite";
import passwordShow from "./modules/passwordShow";
import pureSlider from "./modules/slider";
import tabs from "./modules/tabs";
import validation from "./modules/validation";
import openSearch from "./modules/openSearch";
import openFilter from "./modules/openFilter";
import mobileMenu from "./modules/mobileMenu";
import activeTag from "./modules/activeTag";
import equalHeight from "./modules/equalHeight";
import changeDisplayMode from "./modules/changeDisplayMode";
import showPaymentByCard from "./modules/showPaymentByCard";
import countReviews from "./modules/countReviews";

document.addEventListener('DOMContentLoaded', () => {
    mobileMenu();

    passwordShow();
    modals();
    pureSlider('.reviews-wrapper', 'multiple', false);
    pureSlider('.slider__slides', 'dots', false);
    pureSlider('.item__imgs', 'i', false);
    pureSlider('.big-slider__slides', 'dots', true, '', true);
    pureSlider('.product-imgs__wrapper', 'imgs', false);
    pureSlider('.related-slider', 'multiple', false, 'items', true);
    tabs('.tabs', '.wrapper');
    tabs('.product-info__tabs', '.product-info__wrapper');
    tabs('.faq-page__tabs', '.faq-page__wrapper');
    amount();
    faq('.faq-item');
    faq('.map-item');
    edit();
    calcDisc();
    filter();
    customSelect();

    validation();
    changeAddress();
    addFavorite();
    openSearch();
    openFilter();
    activeTag();
    equalHeight();
    changeDisplayMode();
    showPaymentByCard();
    countReviews();
});